import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as SuccessTick } from "../../assets/svg/success-message-tick.svg";
import { ReactComponent as ErrorTick } from "../../assets/svg/error-message-tick.svg";
/**UI component for showing Success and Failure Alert
 * @param {Object} props Component props
 * @param {string} props.message text to be shown in alert
 * @param {string} props.alertType type of alert 'success' or 'error'
 */
export default function Alert({ message, alertType }) {
  return (
    <div className={`login-dialog-message ${alertType} h5 bold text-white`}>
      <span className="m-r-10">
        {alertType === "success" ? <SuccessTick /> : <ErrorTick />}
      </span>
      {message}
    </div>
  );
}

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  alertType: PropTypes.oneOf(["success", "error"])
};
